import { Box, Card, Skeleton } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

export const PreSaleCardSkeleton: FC = () => (
  <Card sx={{ borderRadius: 2 }}>
    <Skeleton variant="rectangular" height={80} width="100%" />
    <Box sx={{ py: 1, px: 5 }}>
      <SkeletonText variant="small" width="100%" />
    </Box>
  </Card>
)
